// this file is generated by update_shopify_store_data.py at 2026-06-22 20:30:41.228056
var courses = [
    {
        "course_id": "824FD93C-8614-F011-9997-005056A726F7",
        "course_version": 1,
        "name": "Designing a Patient Centered Plan for In-patient Care and Safe Discharge for Hospitalized Adults with Intellectual and Developmental Disabilities (IDD)",
        "course_type": 1,
        "author_information": "Dr. Sarah Ailey Ph.D. APHN, RN FAAN;\r\nDr. Holly Brown, DNP, RN, PMHNP-BC, PMHCS; and\r\nDr. Dianne Cooney Miner PhD, RN FAAN",
        "description": "Throughout this module, we will explore standards of care and evidence-based interventions that foster patient safety and provide for patient comfort and well-being during and after their hospitalization. This module emphasizes the importance of collaboration with the patient and their support system in the development of the plan of care for hospitalization, for discharge and for post hospital care.",
        "learning_objectives_html": "By the time you complete this course, you will be able to:\r\n<ul>\r\n    <li>Design a patient-centered plan of care for hospitalized patients with IDD to:\r\n    <ol>\r\n        <li>Achieve quality outcomes. </li>\r\n        <li>Prevent adverse events.</li>\r\n    </ol>\r\n    </li>\r\n    <li>Incorporate patient-centered nursing interventions into discharge planning with the goal of:\r\n    <ol>\r\n        <li>Achieving a safe transition from the hospital.</li>\r\n        <li>Supporting patients with IDD's continuum of care.</li>\r\n    </ol>\r\n    </li>\r\n</ul>",
        "course_outline_html": "none provided",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "552455CB-0469-E811-B6FF-005056B10E33",
                "course_category_name": "CE Unlimited featuring Challenge Tracks",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F0D93E9B-C313-F011-999F-005056A77B46",
                "course_category_name": "Golisano-CEUnlimited",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BDB7B074-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "Registered Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2E429D0C-4610-EE11-997D-005056A730AF",
                "course_category_name": "Golisano",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53A09CBA-47F5-41DE-ABBC-397BDE607DA7",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B92FC0B9-AF4B-F011-99A4-005056A77B46",
                "course_category_name": "CE Unlimited_BRIDGE (No DEI Courses)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2F5C3339-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "Advance Practice Registered Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0C0B7090-D960-F011-99A0-005056A740BF",
                "course_category_name": "Golisano - Optimizing Care for Hospitalized Individuals with Intellectual and Developmental Disabilities - Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B756B56E-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FEB7B714-954B-46A4-89D6-628F916FB59B",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "<em>The Golisano Institute for Developmental Disability Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Provider Number P0691</em>",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 0.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];